import type { ExternalTableSchema } from '@packages/table-builder';

export const planApprovalTable: ExternalTableSchema = {
  metadata: {
    title: 'Plan Approval',
    entity: 'Plan Approval',
  },

  dataSource: {
    endpoint: '/api/award/api/app/plan-approval/plan-list',
    method: 'GET',
    rowIdField: 'planId',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      PlanOnBoardDate: 'filters.planOnBoardDate',
      PlanEffectiveDate: 'filters.planEffectiveDate',
      PlanApprovalStatusIds: 'filters.planApprovalStatusIds',
    },
    filters: [
      {
        name: 'planOnBoardDate',
        placeholder: 'Plan Onboard Date',
        type: 'date',
      },
      {
        name: 'planEffectiveDate',
        placeholder: 'Plan Effective Date',
        type: 'date',
      },
      {
        name: 'planApprovalStatusIds',
        placeholder: 'Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/award/api/app/plan-approval/plan-status',
          labelField: 'statusName',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    { field: 'planName', header: 'Plan Name', type: 'text', sortable: true, width: 250, visibility: 'locked' },
    { field: 'planTerm', header: 'Plan Term', type: 'text', width: 250, visibility: 'picker' },
    { field: 'planCreationDate', header: 'Plan Onboard Date', type: 'date', sortable: true, width: 200 },
    { field: 'planEffectiveDate', header: 'Plan Effective Date', type: 'date', sortable: true, width: 200, align: 'center' },
    { field: 'planExpiryDate', header: 'Plan Expiry Date', type: 'date', width: 200, align: 'center', visibility: 'picker' },
    { field: 'noOfDocuments', header: 'No. of Documents', type: 'text', sortable: true, width: 180, align: 'center' },
    { field: 'noOfGrants', header: 'No. of Grants', type: 'text', width: 180, align: 'center', visibility: 'picker' },
    {
      field: 'lastModifiedDate',
      header: 'Last Modified Date',
      type: 'date',
      sortable: true,
      width: 180,
      fields: { additionalAccessor: 'planCreationDate' },
    },
    {
      field: 'planApprovalStatus',
      header: 'Status',
      type: 'badge',
      sortable: true,
      width: 200,
      align: 'center',
      badge: {
        statusMap: { Approved: 'success', Rejected: 'error', Pending: 'info' },
        defaultVariant: 'info',
      },
    },
    {
      field: 'evergreenPlan',
      header: 'Evergreen Plan',
      type: 'badge',
      width: 200,
      align: 'center',
      visibility: 'picker',
      conditionalValues: { true: 'Yes', false: 'No' },
      badge: { statusMap: { Yes: 'success', No: 'error' }, defaultVariant: 'info' },
    },
    {
      field: 'dividentEligibility',
      header: 'Dividend Eligibility',
      type: 'badge',
      width: 200,
      align: 'center',
      visibility: 'picker',
      conditionalValues: { true: 'Yes', false: 'No' },
      badge: { statusMap: { Yes: 'success', No: 'error' }, defaultVariant: 'info' },
    },
    { field: 'description', header: 'Description', type: 'text', width: 250, visibility: 'picker' },
    { field: 'boardApprovalDate', header: 'Board Approval Date', type: 'date', width: 200, visibility: 'picker' },
    { field: 'shareHolderApprovalDate', header: 'Shareholder Approval Date', type: 'date', width: 200, visibility: 'picker' },
    { field: 'numberOfSharesAuthorized', header: 'No. of Share Authorized', type: 'number', width: 180, align: 'center', visibility: 'picker' },
    { field: 'numberOfSharesAvailable', header: 'No. of Shares Available', type: 'number', width: 180, align: 'center', visibility: 'picker' },
    { field: 'numberOfSharesUnAvailable', header: 'No. of Shares Unavailable', type: 'number', width: 180, align: 'center', visibility: 'picker' },
    { field: 'uniquePlanNo', header: 'Unique Plan No.', type: 'number', width: 250, visibility: 'picker' },
  ],

  actions: {
    row: [
      { id: 'VIEW_PLAN_APPROVAL', label: 'View' },
      { id: 'APPROVE_PLAN_APPROVAL', label: 'Approve' },
      { id: 'REJECT_PLAN_APPROVAL', label: 'Reject', variant: 'danger' },
      { id: 'VIEW_COMMENTS_PLAN_APPROVAL', label: 'View Comments' },
    ],
  },

  features: {
    search: { enabled: true, placeholder: 'Search Keywords', debounce: 500 },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    columnPreferences: { persistenceKey: 'Plan Approval', resizable: true, reorderable: true },
  },
};
